import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import HomePage from './homePage';
import IosPrivacyPolicy from './IosPrivacyPolicy';
import PrivacyPolicyAndroid from './android_privacy_policy';
import DeleteUserDataKarigarHQ from './DeleteUserDataKarigarHQ';
import Support from './Support';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route
          path="/home"
          element={<HomePage />}
        />
        <Route
          path="/customer-form"
          element={<HomePage />}
        />
        <Route
          path="/"
          element={<HomePage />}
        />
        <Route
          path="/ios_privacy_policy"
          element={<IosPrivacyPolicy />}
        />
        <Route
          path="/android_privacy_policy"
          element={<PrivacyPolicyAndroid />}
        />
        <Route
          path="/delete-data"
          element={<DeleteUserDataKarigarHQ />}
        />
        <Route
          path="/support"
          element={<Support />}
        />
      </Routes>
    </Router>
  );
};

export default App;
